<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title>
        <span class="md-text">Remove from Favorites</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" class="mb-0 mt-4 mb-4" prominent>
          Are you sure you want to remove this product from your favorites?
        </v-alert>
        <div class="d-flex justify-center align-center">
          <div class="mr-4">
            <img class="product-image-delete" :src="product.product_image" />
          </div>
          <div>
            <h4 class="ma-0 text-truncate">
              {{
                product.product_name
                  ? product.product_name.length > 35
                    ? product.product_name.substring(0, 35).concat('...')
                    : product.product_name
                  : ''
              }}
            </h4>
            <span v-if="product.product_brand" class="font-italic font-weight-bold">
              {{ product.product_brand }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          class="text-none"
          small
          @click="removeFavorite"
          :loading="submit_loading"
        >
          Yes, remove it!
        </v-btn>
        <v-btn color="error" small class="text-none" @click="dialog = false"> cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'deleteFavoriteModal',
    props: ['product', 'show', 'component_name'],
    data() {
      return {
        dialog: false,
        submit_loading: false,
      }
    },
    methods: {
      async wait(time = 500) {
        return await new Promise((resolve) => setTimeout(resolve, time))
      },
      async removeFavorite() {
        this.submit_loading = true
        try {
          await axios
            .post(`/api/products/favorite`, {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
              component: this.component_name,
              id_match: this.product.match_id,
              favorite: false,
            })
            .then(async (res) => {
              if (res.data.status) {
                await this.wait(500)
                this.dialog = false
                this.$emit('confirm-delete')
              }
            })
        } catch (e) {
          console.error(e)
        } finally {
          this.submit_loading = false
        }
      },
    },
    watch: {
      show: {
        handler() {
          this.dialog = this.dialog ? false : true
        },
      },
    },
  }
</script>
<style scoped>
  .product-image-delete {
    height: 100px;
  }
</style>
